module.exports = __webpack_public_path__ + "media/images/icons/handshake-3192d76bffaf37ad731ee195ec5108a0.svg";